import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { WorkWidgetHeaderModule } from 'shared/components/work-widget-header/work-widget-header.module';
import { VisitorHistoryModule } from 'shared/components/visitor-history/visitor-history.module';
import { CompactVisitorInfoModule } from 'shared/components/compact-visitor-info/compact-visitor-info.module';
import { ChatMessagesModule } from 'shared/components/chat-messages/chat-messages.module';
import { JoinChatModule } from 'shared/components/join-chat/join-chat.module';
import { LoadingModule } from 'shared/components/loading/loading.module';
import { ChatViewerComponent } from 'shared/components/chat-viewer/chat-viewer.component';
import { ChatActionsModule } from 'shared/components/chat-actions/chat-actions.module';
import { CannedMessageModule } from 'shared/components/canned-message-panel/canned-message-panel.module';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { WorkitemActivityIndicatorModule } from 'shared/components/workitem-activity-indicator/workitem-activity-indicator.module';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    TranslateModule.forChild(),
    WorkWidgetHeaderModule,
    VisitorHistoryModule,
    CompactVisitorInfoModule,
    ChatMessagesModule,
    JoinChatModule,
    LoadingModule,
    ChatActionsModule,
    CannedMessageModule,
    SvgIconModule,
    WorkitemActivityIndicatorModule
  ],
  declarations: [
    ChatViewerComponent
  ],
  exports: [
    ChatViewerComponent
  ]
})
export class ChatViewerModule {}
